const json = {
  certificates: [
    {
      certificateTitle: "Certified Scrum Master ©",
      certificateDate: "May 30, 2021",
      certificateOrganization: "Scrum Alliance ©",
      certificateDescription:
        "Holding a Certified ScrumMaster® (CSM®) certification demonstrates knowledge and ability to support Scrum.",
      certificateLink: "https://bcert.me/sufvbzjjv",
      certificateImage:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/certificates/CSM.png",
    },
    {
      certificateTitle: "Term Dean's Honours List",
      certificateDate: "2A, 3A, 3B, 4A, 4B",
      certificateOrganization:
        "University of Waterloo - Faculty of Engineering",
      certificateDescription:
        "Graduated within the top 10% of my class in Mechatronics Engineering.",
      certificateImage:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/certificates/waterloo_engineering.jpg",
    },
  ],
};

export default json;
